(function (global) {
  'use strict';

  if (global.CmxBusinessHours && typeof global.CmxBusinessHours.initialize === 'function') {
    global.CmxBusinessHours.initialize();
    return;
  }

  var SELECTOR = '[data-cmx-business-hours]';
  var DEFAULT_TIME_ZONE = 'Europe/Madrid';
  var formatterCache = {};
  var refreshTimer = null;

  var DEFAULT_WEEKLY_SCHEDULE = {
    0: [],
    1: [[510, 840], [930, 1110]],
    2: [[510, 840], [930, 1110]],
    3: [[510, 840], [930, 1110]],
    4: [[510, 840], [930, 1110]],
    5: [[510, 840]],
    6: []
  };

  function parseTimeInterval(value) {
    var source = String(value || '').trim().toLowerCase();
    if (!source || source === 'cerrado' || source === 'closed') return null;

    var match = source.match(/^([01]?\d|2[0-3]):([0-5]\d)\s*[-–—]\s*([01]?\d|2[0-3]):([0-5]\d)$/);
    if (!match) return null;

    var start = (Number(match[1]) * 60) + Number(match[2]);
    var end = (Number(match[3]) * 60) + Number(match[4]);
    if (start >= end) return null;

    return [start, end];
  }

  function parseDayIntervals(value) {
    var source = String(value || '').trim();
    if (!source || /^(cerrado|closed)$/i.test(source)) return [];

    var tokens = source.split(/\s*[,;]\s*/);
    var intervals = [];

    for (var index = 0; index < tokens.length; index += 1) {
      var interval = parseTimeInterval(tokens[index]);
      if (!interval) return [];
      intervals.push(interval);
    }

    return intervals;
  }

  function getWeeklySchedule(options) {
    var config = options || {};
    var dailyScheduleValues = [
      config.monday,
      config.tuesday,
      config.wednesday,
      config.thursday,
      config.saturday,
      config.sunday
    ];
    var hasDailySchedule = dailyScheduleValues.some(function (value) {
      return value !== undefined && value !== null;
    });

    if (hasDailySchedule) {
      return {
        0: parseDayIntervals(config.sunday),
        1: parseDayIntervals(config.monday),
        2: parseDayIntervals(config.tuesday),
        3: parseDayIntervals(config.wednesday),
        4: parseDayIntervals(config.thursday),
        5: parseDayIntervals(config.friday),
        6: parseDayIntervals(config.saturday)
      };
    }

    var legacyScheduleValues = [
      config.weekdayMorning,
      config.weekdayAfternoon,
      config.friday
    ];
    var hasLegacySchedule = legacyScheduleValues.some(function (value) {
      return value !== undefined && value !== null;
    });

    if (!hasLegacySchedule) return DEFAULT_WEEKLY_SCHEDULE;

    var weekdayIntervals = [
      parseTimeInterval(config.weekdayMorning),
      parseTimeInterval(config.weekdayAfternoon)
    ].filter(Boolean);
    var fridayInterval = parseTimeInterval(config.friday);

    return {
      1: weekdayIntervals,
      2: weekdayIntervals,
      3: weekdayIntervals,
      4: weekdayIntervals,
      5: fridayInterval ? [fridayInterval] : []
    };
  }

  function parseClosedDates(value) {
    var tokens = Array.isArray(value) ? value : String(value || '').split(/[\s,;]+/);
    var dates = {};

    tokens.forEach(function (token) {
      var date = String(token || '').trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        dates[date] = true;
      }
    });

    return dates;
  }

  function getFormatter(timeZone) {
    if (!formatterCache[timeZone]) {
      formatterCache[timeZone] = new Intl.DateTimeFormat('en-CA-u-ca-gregory-nu-latn', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      });
    }

    return formatterCache[timeZone];
  }

  function getZonedParts(value, timeZone) {
    var date = value && typeof value.getTime === 'function'
      ? new Date(value.getTime())
      : new Date(value);

    if (Number.isNaN(date.getTime())) return null;

    try {
      var values = {};
      getFormatter(timeZone).formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') values[part.type] = Number(part.value);
      });

      if (!values.year || !values.month || !values.day || Number.isNaN(values.hour) || Number.isNaN(values.minute)) {
        return null;
      }

      var isoDate = [
        String(values.year).padStart(4, '0'),
        String(values.month).padStart(2, '0'),
        String(values.day).padStart(2, '0')
      ].join('-');

      return {
        isoDate: isoDate,
        weekday: new Date(Date.UTC(values.year, values.month - 1, values.day)).getUTCDay(),
        minutes: (values.hour * 60) + values.minute
      };
    } catch (error) {
      return null;
    }
  }

  function isOpenAt(value, options) {
    var config = options || {};
    var timeZone = config.timeZone || DEFAULT_TIME_ZONE;
    var zoned = getZonedParts(value, timeZone);

    if (!zoned) return false;
    if (parseClosedDates(config.closedDates)[zoned.isoDate]) return false;

    var intervals = getWeeklySchedule(config)[zoned.weekday] || [];
    return intervals.some(function (interval) {
      return zoned.minutes >= interval[0] && zoned.minutes < interval[1];
    });
  }

  function refreshElement(element, value) {
    var instant = value == null ? new Date() : value;
    var open = isOpenAt(instant, {
      timeZone: element.getAttribute('data-cmx-time-zone') || DEFAULT_TIME_ZONE,
      closedDates: element.getAttribute('data-cmx-closed-dates') || '',
      monday: element.getAttribute('data-cmx-schedule-monday'),
      tuesday: element.getAttribute('data-cmx-schedule-tuesday'),
      wednesday: element.getAttribute('data-cmx-schedule-wednesday'),
      thursday: element.getAttribute('data-cmx-schedule-thursday'),
      friday: element.getAttribute('data-cmx-schedule-friday'),
      saturday: element.getAttribute('data-cmx-schedule-saturday'),
      sunday: element.getAttribute('data-cmx-schedule-sunday'),
      weekdayMorning: element.getAttribute('data-cmx-schedule-weekday-morning'),
      weekdayAfternoon: element.getAttribute('data-cmx-schedule-weekday-afternoon')
    });

    element.hidden = !open;
    element.setAttribute('data-cmx-business-hours-state', open ? 'open' : 'closed');

    return open;
  }

  function refreshAll(root, value) {
    var scope = root || global.document;
    if (!scope) return 0;

    var elements = [];
    if (typeof scope.matches === 'function' && scope.matches(SELECTOR)) {
      elements.push(scope);
    }
    if (typeof scope.querySelectorAll === 'function') {
      elements = elements.concat(Array.prototype.slice.call(scope.querySelectorAll(SELECTOR)));
    }

    elements.forEach(function (element) {
      refreshElement(element, value);
    });

    return elements.length;
  }

  function scheduleRefresh() {
    if (refreshTimer || typeof global.setTimeout !== 'function') return;

    var delay = 60050 - (Date.now() % 60000);
    refreshTimer = global.setTimeout(function () {
      refreshTimer = null;
      refreshAll();
      scheduleRefresh();
    }, delay);
  }

  function initialize() {
    if (!global.document) return;
    refreshAll(global.document);
    scheduleRefresh();
  }

  global.CmxBusinessHours = {
    getZonedParts: getZonedParts,
    getWeeklySchedule: getWeeklySchedule,
    initialize: initialize,
    isOpenAt: isOpenAt,
    parseClosedDates: parseClosedDates,
    parseDayIntervals: parseDayIntervals,
    parseTimeInterval: parseTimeInterval,
    refreshAll: refreshAll,
    refreshElement: refreshElement
  };

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    global.document.addEventListener('shopify:section:load', function (event) {
      refreshAll(event.target);
    });
    global.document.addEventListener('visibilitychange', function () {
      if (global.document.visibilityState === 'visible') refreshAll();
    });
    if (typeof global.addEventListener === 'function') {
      global.addEventListener('pageshow', function () {
        refreshAll();
      });
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
